<template>
  <div class="change-transaction-category-settings-popup">
    <popup :buttons="buttonOptions"
           :back-action="back">
      <template v-slot:title>
        תמיד לשים ב<span class="selected-category" :class="selectedCategory.cashflowCategory">"{{ selectedCategory.pluralLabel }}"</span>
        הוצאות מ-
      </template>
      <template v-slot:content>
        {{ transaction.businessName }}
      </template>
    </popup>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import BaseUI from 'base-ui';
import ModalBus from '../../../../../../../../../../event-bus/modal-bus';
import ChangeTransactionCategoryPopup from './ChangeTransactionCategoryPopup.vue';
import ChangeTransactionCategorySummaryPopup from './ChangeTransactionCategorySummaryPopup.vue';
import Segment from '../../../../../../../../../../Segment';

export default {
  name: 'ChangeTransactionCategorySettingsPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  created() {
    Segment.trackUserInteraction('ChangeTransactionCategorySettingsPopup_Shown', {
      businessName: this.transaction.businessName,
      originalCategory: this.transaction.expense,
      transactionId: this.transaction.transactionId,
    });
  },
  computed: {
    ...mapState('editTransaction', ['transaction']),
    ...mapGetters('editTransaction', ['selectedCategory', 'ENRICHMENT_INPUT_TYPES', 'categoryToVariant']),
    title() {
      return `תמיד לשים ב"${this.selectedCategory.label}"הוצאות מ"${this.transaction.businessName}"?`;
    },
    buttonOptions() {
      return [{
        title: 'כן, תמיד',
        action: () => this.onSave(this.ENRICHMENT_INPUT_TYPES.BUSINESS_NAME),
        variant: this.categoryToVariant[this.selectedCategory.cashflowCategory],
      }, {
        title: 'לא, רק את ההוצאה הזו',
        action: () => this.onSave(this.ENRICHMENT_INPUT_TYPES.TRANSACTION_ID),
        variant: 'secondary-black',
      }];
    },
  },
  methods: {
    ...mapMutations('editTransaction', ['setCategoryRuleType']),
    back() {
      Segment.trackUserInteraction('ChangeTransactionCategorySettingsPopup_BackClicked', {
        businessName: this.transaction.businessName,
        originalCategory: this.transaction.expense,
        transactionId: this.transaction.transactionId,
      });
      ModalBus.$emit('open', {
        component: ChangeTransactionCategoryPopup,
        props: {},
      });
    },
    onSave(type) {
      Segment.trackUserInteraction('ChangeTransactionCategorySettingsPopup_AnswerClicked', {
        businessName: this.transaction.businessName,
        ruleType: type,
        transactionId: this.transaction.transactionId,
      });
      this.setCategoryRuleType(type);
      ModalBus.$emit('open', {
        component: ChangeTransactionCategorySummaryPopup,
        props: {},
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../../scss/category-color-mixins';

  .change-transaction-category-settings-popup {
    .selected-category {
      @include category-color;
    }
  }

</style>
